<template lang="pug">

	div#app
		
		sig-header
		mapa
		bottom-bar
		search-box(:tools="searchTools")
		tool-box(:tools="tools")

</template>

<script>

import SigHeader from './components/Header';
import Mapa from './components/Mapa';
import ToolBox from './components/ToolBox';
import SearchBox from './components/SearchBox';
import Pesquisa from './components/Pesquisa';
import InformacoesPonto from './components/inspecao/InformacoesPonto';
import Inspecao from './components/inspecao/Inspecao';
import Zoom from './components/Zoom';
import Camadas from './components/camadas/Camadas';
import AdicaoCamadas from './components/adicaoCamadas/AdicaoCamadas';
import BottomBar from './components/BottomBar';
import Config from '@/config.js';
import camadasService from '@/services/camadasService';

import { mapMutations } from 'vuex';

export default {
	name: 'app',
	
	components: { Mapa, ToolBox, SigHeader, BottomBar, SearchBox },
	
	data () {
		return {
			tools: [ Zoom, Camadas, AdicaoCamadas ],
			searchTools: [ Pesquisa, InformacoesPonto, Inspecao ],
			config: Config
		};
	},

	created () {

		this.initializeGlobalMapVariables();
		
		this.disableDefaultRightClickAction();
		
	},

	mounted () {
		camadasService.findAll((data) => this.setEstruturaCamadas(data));
	},

	methods: {
		
		initializeGlobalMapVariables () {

			this.setMinZoom(this.initialBaseMap.minZoom);
			this.setMaxZoom(this.initialBaseMap.maxZoom);

			this.setCoordinate({
				lat: this.config.center[0],
				lng: this.config.center[1]
			});
		},

		disableDefaultRightClickAction () {

			// Bloqueia o comportamento default dos navegadores ao utilizar o botão direito do mouse
			$('html').bind('contextmenu', (e) => {
				return false;
			});

		},

		...mapMutations([
			
			'setMinZoom',
			'setMaxZoom',
			'setEstruturaCamadas',
			'setCoordinate'
		])
	},

	computed: {
		
		initialBaseMap () {
			return _.find(this.config.baseMaps, (baseMap) => {
				return baseMap.default;
			});
		}
	}
};

</script>

<style lang="scss"scoped>

#app {
	width: 100%;
	height: 100%;
}

</style>



// WEBPACK FOOTER //
// App.vue?14025293